import React, { useState } from "react";
import { useBrandLogo } from "@/lib/brandLogo";
import BrandName from "@/components/BrandName";

/**
 * Company logo as an Apple-style app icon (rounded square, hairline edge, soft depth),
 * optionally followed by the NAVI CARE name on the right of the icon (`name`).
 * Falls back to a blue "n" icon until a logo is uploaded.
 */
export default function BrandMark({ size = 40, className = "", name = false, nameSize, services = false }) {
  const src = useBrandLogo();
  const [failed, setFailed] = useState(false);
  const box = { width: size, height: size, borderRadius: Math.round(size * 0.2237) };
  const icon = (
    <span className={`nd-brandmark ${className}`} style={box} aria-hidden="true">
      {src && !failed
        ? <img src={src} alt="" onError={() => setFailed(true)} draggable={false} />
        : <span className="nd-brandmark-fallback" style={{ fontSize: size * 0.52 }}>n</span>}
    </span>
  );
  if (!name) return icon;
  return (
    <span className="nd-brandlockup" aria-label="NAVI CARE">
      {icon}
      <BrandName mark={false} services={services} style={{ fontSize: nameSize || Math.round(size * 0.52) }} />
    </span>
  );
}
